Vue.component('chosen-select', {
    template: '<select aria-label="select" class="filter-dropdown" :id="id" v-model="proxyValue" :disabled="readonly"><slot></slot></select>',
    props: ['value', 'id', 'readonly', 'search'],
    data: function() {
        return {
            inner_search: false
        }
    },
    computed: {
        proxyValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        }
    },
    mounted() {
        let threshold = 10;

        if(this.search !== undefined) {
            this.inner_search = true;
            threshold = 0;
        }

        $(this.$el).chosen({
            width: '100%',
            no_results_text: Lang.langGet("No results found"),
            search_contains: true,
            placeholder_text_single: Lang.langGet("Select an option..."),
            placeholder_text_multiple: Lang.langGet("Select some options..."),
            disable_search_threshold: threshold,
            disable_search: !this.inner_search
        }).change((ev) => {
            this.proxyValue = ev.target.value;
        });

        const searchInputs =  $(this.$el).parent().find('.chosen-search-input').toArray();
        searchInputs.forEach(element => {
            element.setAttribute('aria-label','search');
        });
    },
    updated() {
        $(this.$el).trigger('chosen:updated');
    },
    destroyed() {
        $(this.$el).chosen('destroy');
    }
});

Vue.component('chosen-multiselect', {
    template: '<select aria-label="multi-select" :id="id" multiple="multiple" v-model="proxyValue" :disabled="readonly" v-bind:class="classes"><slot></slot></select>',
    props: ['value', 'id', 'readonly', 'hierarchical', 'transNoResult', 'transPlaceholderSingle', 'transPlaceholderMulti', 'createableValues'],
    data: function() {
        return {
            text_list: [],
            inner_value: [],
        }
    },
    computed: {
        proxyValue: {
            get() {
                return this.value ?? this.inner_value;
            },
            set(newValue) {
                if (this.value) {
                    this.$emit('input', newValue);
                    this.$emit('onChange');
                } else {
                    this.inner_value = newValue;
                }
            }
        },
        classes: function () {
            if (this.hierarchical === true) {
                return 'hierarchical';
            }

            return '';
        },
        noResult: function () {
            if (typeof this.transNoResult !== 'undefined') {
                return this.transNoResult;
            } else {
                return Lang.langGet("No results found");
            }
        },
        placeholderSingle: function () {
            if (typeof this.transPlaceholderSingle !== 'undefined') {
                return this.transPlaceholderSingle;
            } else {
                return Lang.langGet("Select an option...");
            }
        },
        placeholderMulti: function () {
            if (typeof this.transPlaceholderMulti !== 'undefined') {
                return this.transPlaceholderMulti;
            } else {
                return Lang.langGet("Select some options...");
            }
        }
    },
    methods: {
        updateSelected: function () {
            let choices = $(this.$el).parent().find('.chosen-container.hierarchical .chosen-choices .search-choice');
            _.forEach(choices, function (element) {
                let span = element.childNodes[0];
                let text = span.innerHTML.trim();
                let firstSpace = text.indexOf(' ');

                if (firstSpace > 0 && text.substr(firstSpace - 1, 1) === '-') {
                    span.innerHTML = text.substr(firstSpace);
                }
            });
            this.text_list = [];
            let options = $(this.$el).find('option');
            _.forEach(options, (option) => {
                let text = option.innerHTML.trim();
                this.text_list.push(text);
            });
        },
        createValue: function () {
            let search_text = $(this.$el).parent().find('.search-field input').val();
            if (typeof search_text !== 'string' || search_text.length === 0) {
                return;
            }
            search_text = search_text.replace(/<[^>]*>?/gm, '');
            $(this.$el).append(
                "<option value='#NEW-" + search_text + "'>" + search_text + "</option>"
            );
            $(this.$el).trigger('chosen:updated');
            this.$nextTick(() => {
                this.proxyValue.push('#NEW-' + search_text);
                $(this.$el).parent().find('.search-field .create-value-btn').addClass('hidden');
            })
        },
        removeValue: function (index) {
            $(this.$el).find('option[value="' + index + '"]').remove();
            $(this.$el).trigger('chosen:updated');
        }
    },
    mounted() {
        $(this.$el)
            .chosen({
                width: '100%',
                no_results_text: this.noResult,
                search_contains: true,
                inherit_select_classes: true,
                placeholder_text_single: this.placeholderSingle,
                placeholder_text_multiple: this.placeholderMulti,
                disable_search_threshold: 10
            })
            .change((ev, pa) => {
                if (typeof pa !== 'undefined' && typeof pa.selected !== 'undefined') {
                    this.proxyValue.push(pa.selected);
                }

                if (typeof pa !== 'undefined' && typeof pa.deselected !== 'undefined') {
                    this.proxyValue.splice(_.indexOf(this.proxyValue, pa.deselected), 1);

                    if (pa.deselected.startsWith('#NEW')) {
                        this.removeValue(pa.deselected);
                    }
                }
            })
            .ready(() => {
                if (this.createableValues) {
                    $(this.$el).parent().find('.search-field').append(
                        "<i class='create-value-btn btn fa fa-plus hidden' style='position:absolute;right:0;top:2px;' tabindex='0' onclick='EaseEventBus.fire(\"chosenCreateValue-" + this.id + "\")'></i>"
                    )

                    const searchInputs =  $(this.$el).parent().find('.chosen-search-input').toArray();
                    searchInputs.forEach(element => {
                        element.setAttribute('aria-label','search');
                    });
                }

                this.updateSelected();
            })
            .on('chosen:hiding_dropdown', () => {
                $(this.$el).parent().find('.search-field .create-value-btn').addClass('hidden');
            })

        $(this.$el).parent().find('.search-field input')
            .keyup(() => {
                let search_text = $(this.$el).parent().find('.search-field input').val();
                if (typeof search_text !== 'string' || search_text.length === 0) {
                    return;
                }
                search_text = search_text.charAt(0).toUpperCase() + search_text.slice(1);
                if (search_text && !this.text_list.includes(search_text)) {
                    $(this.$el).parent().find('.search-field .create-value-btn').removeClass('hidden');
                } else {
                    $(this.$el).parent().find('.search-field .create-value-btn').addClass('hidden');
                }
            })


        EaseEventBus.listen('chosenCreateValue-' + this.id, () => {
            this.createValue();
        })
    },
    updated() {
        $(this.$el).trigger('chosen:updated');

        const searchInputs =  $(this.$el).parent().find('.chosen-search-input').toArray();
        searchInputs.forEach(element => {
            element.setAttribute('aria-label','search');
        });

        this.updateSelected();
    },
    destroyed() {
        $(this.$el).chosen('destroy');
    }
});
